import { observable } from 'rewire-core';

export type IEmployeeViewType = 'details' | 'balances';

interface IEmployeeViewTypeState {
  view: IEmployeeViewType;
}

class EmployeeViewTypeModel {
  state: IEmployeeViewTypeState;

  constructor() {
    this.state = observable({view: 'details'});
  }

  get view(): IEmployeeViewType {
    return this.state.view;
  }

  set view(view: IEmployeeViewType) {
    this.state.view = view;
  }

  handleViewButtonClick = (view: IEmployeeViewType) => ()    => this.view = view;
  isView                = (view: IEmployeeViewType): boolean => this.view === view;
}

const employeeViewTypeModel = new EmployeeViewTypeModel();
export default employeeViewTypeModel;